import { QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { logger } from '@utils/logger';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        const axiosError = error as AxiosError;
        const status = axiosError.response?.status;
        if (status && [401, 403, 404].includes(status)) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        logger.error('Mutation error', error, 'QueryClient');
      },
    },
  },
});
